import util from "../../util"
import {ElectronApi} from "../../util/electron/index.js";
import u from "../../util/index.js";

const {Ajax, AJAX_OPTION} = util;
const USE_INTT_ID = window._USE_INTT_ID || '';
const RGSN_DTTM = window._RGSN_DTTM || '';
const USER_ID = window._USER_ID || '';

function getTeamsOAuthClientId() {
    switch (true) {
        case _USE_INTT_ID.indexOf("KYOWON") > -1  :
            return {
                client_id: 'ec8b1ab2-a5c9-41c3-983f-c0b00fc8b818',
                tenant_id: '6aba328a-b414-4a52-bf31-46f3e35e8b39',
            }
        //mjs
        case Often.isGlobal() && _USE_INTT_ID.indexOf("BFLOW_300000009787") > -1 :
            return {
                client_id: '7396615a-f613-4fb0-a2d7-682d74654686',
                tenant_id: '59242678-28eb-4391-831c-23557bc72f5c',
            }
        case _USE_INTT_ID.indexOf("LOCAL") > -1 || location.href.indexOf("entertest") > -1 :
            return {
                client_id: '9adf41af-3031-41a0-aaad-eeba5a7a35ab',
                tenant_id: 'Q9h8Q~bH.LlvJfq0ysUTgUxY.FZOX3q76D-njaD5',
            }
        case Often.isGlobal() :
            return {
                client_id: '7da91c41-0c22-4145-b7f3-c064e366f63d',
                tenant_id: 'cd16b666-9fd3-4188-847b-843c857a62d8',
            }
        default:
            return {
                client_id: 'e7d7139f-f062-4d0e-87a2-04cbd368fd96',
                tenant_id: 'cd16b666-9fd3-4188-847b-843c857a62d8',
            };
    }
}

async function connectAzure() {
    let state = USER_ID;
    let origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    if (!Often.isAct("signin")) {
        const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
        const dat = await ajaxSpace.executeApi("FLOW_USE_INTT_INFM_R001", {USE_INTT_ID: USE_INTT_ID});
        const subDom = Mutil.n2v(dat["SUB_DOM"], "").toLowerCase();
        if (location.host.startsWith(`${subDom}.`)) {
            origin = origin.replace(`${subDom}.`, '');
        }
    }
    const {client_id, tenant_id} = getTeamsOAuthClientId();
    const targetUrl = "https://login.microsoftonline.com/organizations/oauth2/v2.0/authorize?" +
        "client_id=" + client_id + "&" +
        "response_type=code&" +
        "redirect_uri=" + (origin + "/msteams_oauth.act&") +
        "response_mode=query&" +
        "scope=offline_access%20user.read%20https://graph.microsoft.com/Directory.Read.All&" +
        "prompt=login&" +
        "state=" + state;

    const width = 500;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    window.open(targetUrl, "_blank",
        "width=" + width + ",height=" + height + ",left=" + left + ",top=" + top);
    return;
}

async function isConnected() {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    const data = await ajaxSpace.executeApi("FLOW_EXT_SERVICE_R001", {});
    let connected = false;
    if (data.EXT_SERVICE_REC && data.EXT_SERVICE_REC.length > 0) {
        $.each(data.EXT_SERVICE_REC, function (i, v) {
            if (v.EXT_SERVICE_NM === 'MsTeams') {
                connected = true;
            }
        })
    }
    return connected;
}

async function getAzureOrgAPI() {
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    const data = await ajaxSpace.executeApi("MJS_AZURE_ORG_U001", {
        USE_INTT_ID: USE_INTT_ID,
        RGSN_DTTM: RGSN_DTTM,
    });
}

async function getAzureData() {
    let result;
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    result = await ajaxSpace.executeApi("MJS_AZURE_ORG_C001", {
        USE_INTT_ID: USE_INTT_ID,
        RGSN_DTTM: RGSN_DTTM
    });
    return result;
}

async function updateAzureInactiveData() {
    let result;
    const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
    result = await ajaxSpace.executeApi("MJS_AZURE_ORG_D001", {
        USE_INTT_ID: USE_INTT_ID,
        RGSN_DTTM: RGSN_DTTM
    });
    return result;
}

async function updateUser(userRec, pageCnt) {
    let result = '';
    try {
        const ajaxSpace = new Ajax({packetOption: AJAX_OPTION.PREVENT_EXECUTE});
        result = await ajaxSpace.executeApi("MJS_AZURE_ORG_C001", {
            USE_INTT_ID: USE_INTT_ID,
            RGSN_DTTM: RGSN_DTTM,
            USER_REC: userRec,
            MODE: pageCnt
        });
    } catch (e) {
        console.error(`데이터: ${userRec}\n페이징 수: ${pageCnt}`);
    }
    return result;
}

/**
 *  Azure 상에 없는 유저들 비활성화 처리
 *  ONLY FOR MJS
 */
async function inactivateUserFromAzure() {
    const wait_view = waitView.call($("#loadingPendingLayerPopup"));
    //Azure 상에 존재하지 않는 유저들을 비활성화 처리중입니다. 잠시 대기해주세요.
    wait_view.start(function () {
        return 'Azure上に存在しないユーザーを無効化しています。しばらくお待ちください。'
    });
    try {
        const result = await updateAzureInactiveData();
        if (!result.COMMON_HEAD.ERROR) {
            u.toast('info', `${result.TOTAL_CNT} ユーザーの無効化が完了しました。`);
            const exOrder = ['USE_INTT_NM', 'FLNM', 'DVSN_NM', 'JBCL_NM', 'USER_ID', 'RGSN_DTTM'];
            const exName = ['会社情報', '名前', '部署', '役職', 'メール（ID', '加入日'];
            simpleTableToExcelJson('無効ユーザー', result.MISSING_USER_REC, exOrder, exName, 1);
        } else {
            u.toast("error", i18next.t(exception.error.update));
        }
    } catch (e) {
        console.error(e);
    } finally {
        wait_view.end();
    }
}

async function getOrganizationData() {
    let connected = await isConnected();
    let updateFailedUser = {};
    let userCnt;
    let dvsnCnt;
    if (!connected) { //연동 안되어있으면 연동먼저
        await connectAzure();
    } else { //연동되어있으면 바로 가져오기
        const wait_view = waitView.call($("#loadingPendingLayerPopup"));
        wait_view.start(function () {
            return 'Azure部門とユーザーを取得中です。<br> これには最大で5分かかる場合があります。'
        });
        try {
            const orgData = await getAzureData();
            if (!orgData.COMMON_HEAD.ERROR) {
                userCnt = orgData["USER_CNT"];
                dvsnCnt = orgData["DVSN_CNT"];
                //u.toast("info", `The group has been updated with ${dvsnCnt} division(s).\n Now, ${userCnt} user(s) will begin updating.`);
                const userData = orgData["USER_REC"];
                const chunkSize = 200;
                let startIndex = 0;
                updateFailedUser = {};
                let pageCnt = 1;
                do {
                    const chunk = userData.slice(startIndex, startIndex + chunkSize);
                    const chunkResult = await updateUser(chunk, pageCnt);
                    if (!chunkResult || chunkResult.COMMON_HEAD.ERROR || chunkResult["USER_CNT"] !== "Y") {
                        updateFailedUser = {...updateFailedUser, ...chunk};
                    }
                    startIndex += chunkSize;
                    pageCnt++;
                } while (startIndex < userData.length);
            } else {
                updateFailedUser = orgData["USER_REC"];
                u.toast('error', "fail to load azure data!!");
                throw new Error("user load Error");
            }
            if (updateFailedUser.length > 0) {
                u.toast("error", `${updateFailedUser.length} user(s) update Error`);
                throw new Error("user update Error");
            } else {
                u.toast('info', `${dvsnCnt} 部門と ${userCnt} ユーザーの読み込みが完了しました。`);
            }
        } catch (e) {
            console.error(e);
        } finally {
            wait_view.end();
        }
    }
    return updateFailedUser;
}

function getProfileJson(userId) {
    const isElectron = ElectronApi.Comm.isElectron();
    return {
        "USER_ID": userId,
        "ID_GB": SignCode.TYPE.AZURE,
        "EMAIL": "",
        "USER_NM": "",
        "OBJ_CNTS_NM": (isElectron ? "desktop" : ""),
    };
}

function goAzureLogin(userId) {
    CommonLogin.goLogin(getProfileJson(userId));
    return;
}

export {getOrganizationData, connectAzure, goAzureLogin, inactivateUserFromAzure}